import { useSyncExternalStore } from 'react';

/** A tiny hash router: #/, #/session, #/phrases, #/phrase/cafe-007, #/stories, #/story/s1e01, #/settings, #/reading, #/about. */
export type Route =
  | { name: 'today' }
  | { name: 'session' }
  | { name: 'phrases'; lesson?: string }
  | { name: 'phrase'; id: string }
  | { name: 'stories' }
  | { name: 'story'; id: string }
  | { name: 'settings' }
  | { name: 'reading' }
  | { name: 'about' };

export function parse(hash: string): Route {
  const path = hash.replace(/^#/, '') || '/';
  const parts = path.split('/').filter(Boolean);
  switch (parts[0]) {
    case 'session':
      return { name: 'session' };
    case 'phrases':
      return parts[1] ? { name: 'phrases', lesson: decodeURIComponent(parts[1]) } : { name: 'phrases' };
    case 'phrase':
      return parts[1] ? { name: 'phrase', id: decodeURIComponent(parts[1]) } : { name: 'phrases' };
    case 'stories':
      return { name: 'stories' };
    case 'story':
      return parts[1] ? { name: 'story', id: decodeURIComponent(parts[1]) } : { name: 'stories' };
    case 'settings':
      return { name: 'settings' };
    case 'reading':
      return { name: 'reading' };
    case 'about':
      return { name: 'about' };
    default:
      return { name: 'today' };
  }
}

function subscribe(listener: () => void) {
  window.addEventListener('hashchange', listener);
  return () => window.removeEventListener('hashchange', listener);
}

const getHash = () => window.location.hash;

export function useRoute(): Route {
  const hash = useSyncExternalStore(subscribe, getHash, () => '');
  return parse(hash);
}

export function navigate(path: string, replace = false) {
  const hash = `#${path}`;
  if (replace) {
    history.replaceState(null, '', hash);
    window.dispatchEvent(new HashChangeEvent('hashchange'));
  } else if (window.location.hash !== hash) {
    window.location.hash = path;
  }
  window.scrollTo({ top: 0 });
}

export function href(path: string): string {
  return `#${path}`;
}
